NS("System");

System.NumSeq = Static({
    names: {},

    next: function(name, initial) {
        if (!this.names[name]) {
            this.names[name] = parseInt(initial || 0, 10);
        }

        return ++this.names[name];
    }
});
